import {
  setSelectedLimitsWarehouseDateAction,
  setStartCoefficientsLoadingAction,
  setStartWarehousesLoadingAction,
  setStopCoefficientsLoadingAction,
  setStopWarehousesLoadingAction,
  setWarehousesAction,
  setFilteredWarehousesAction,
  setCoefficientsReportAction,
  setFilteredCoefficientsReportAction,
  setCostForPaletteAction,
} from './actions';
import { TWarehousesLimitsStorage } from './types';

type TActions =
  | ReturnType<typeof setWarehousesAction>
  | ReturnType<typeof setSelectedLimitsWarehouseDateAction>
  | ReturnType<typeof setStartWarehousesLoadingAction>
  | ReturnType<typeof setStopWarehousesLoadingAction>
  | ReturnType<typeof setStartCoefficientsLoadingAction>
  | ReturnType<typeof setStopCoefficientsLoadingAction>
  | ReturnType<typeof setFilteredWarehousesAction>
  | ReturnType<typeof setCoefficientsReportAction>
  | ReturnType<typeof setFilteredCoefficientsReportAction>
  | ReturnType<typeof setCostForPaletteAction>;

export const initialState: TWarehousesLimitsStorage = {
  warehouses: [],
  warehousesLimits: [],
  limitsWarehouseDate: null,
  areWarehousesLoading: false,
  areLimitsLoading: false,
  filteredWarehouses: [],
  coefficientsReport: null,
  filteredCoefficientsReport: null,
  allowedDates: null,
  costForPalette: 0,
};

export const DELIVERY_TYPES = {
  boxes: 'boxes',
  palette: 'palette',
  superSafe: 'superSafe',
} as const;

const reducer = (
  state: TWarehousesLimitsStorage = initialState,
  action: TActions,
) => {
  switch (action.type) {
    case setCostForPaletteAction.type:
      return { ...state, costForPalette: action.payload };

    case setWarehousesAction.type:
      return { ...state, warehouses: action.payload };

    case setCoefficientsReportAction.type: {
      const { warehousesFilters, coefficientsReport, allowedDates } =
        action.payload;

      return {
        ...state,
        coefficientsReport,
        warehouses: warehousesFilters,
        filteredWarehouses: warehousesFilters,
        allowedDates,
      };
    }

    case setFilteredCoefficientsReportAction.type:
      return { ...state, filteredCoefficientsReport: action.payload };

    case setSelectedLimitsWarehouseDateAction.type:
      return { ...state, limitsWarehouseDate: action.payload };

    case setStartWarehousesLoadingAction.type:
      return { ...state, areWarehousesLoading: true };

    case setStopWarehousesLoadingAction.type:
      return { ...state, areWarehousesLoading: false };

    case setStartCoefficientsLoadingAction.type:
      return { ...state, areLimitsLoading: true };

    case setStopCoefficientsLoadingAction.type:
      return { ...state, areLimitsLoading: false };

    case setFilteredWarehousesAction.type:
      return { ...state, filteredWarehouses: action.payload };

    default:
      return state;
  }
};

export default reducer;
